import React from 'react'

export function TimezoneEditor({ timezone, options = [], onChange, onSave, error, dirty = false }) {
  return (
    <div>
      <h4 className="dome-color-darkest-grey" style={{ marginBottom: 12 }}>
        Submission Timezone
      </h4>
      <p className="dome-p2 dome-color-med-grey" style={{ marginBottom: 16 }}>
        Submission hours and holiday observance are evaluated in this timezone.
      </p>
      <div className="dome-d-flex dome-align-center dome-gap6" style={{ marginBottom: 12 }}>
        <select
          aria-label="Submission timezone"
          value={timezone || ''}
          onChange={(e) => onChange(e.target.value)}
          style={{ minWidth: 280 }}
        >
          {options.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </div>
      <div className="dome-d-flex dome-align-center dome-gap6">
        <button
          type="button"
          onClick={onSave}
          className={`dome-btn dome-btn-base ${dirty ? 'dome-btn-green-stroke' : 'dome-btn-disabled'}`}
          disabled={!dirty}
        >
          Save Timezone
        </button>
        {error && <span className="text-danger dome-p3">{error}</span>}
      </div>
    </div>
  )
}
